/**
 * Basic product form handler
 * Adds products to cart with support for custom properties
 */

import { cart } from '../helpers/cart'

export class ProductForm extends HTMLElement {
  private form: HTMLFormElement

  constructor() {
    super()
    // Create internal form element
    this.form = document.createElement('form')
    // Move all children to the form
    while (this.firstChild) {
      this.form.appendChild(this.firstChild)
    }
    // Copy attributes from custom element to form
    Array.from(this.attributes).forEach((attr) => {
      if (attr.name !== 'is') {
        this.form.setAttribute(attr.name, attr.value)
      }
    })
    this.appendChild(this.form)
    this.form.addEventListener('submit', this.handleProductAdd.bind(this))
  }

  async handleProductAdd(event: SubmitEvent) {
    event.preventDefault()
    const form = new FormData(this.form)

    const quantityValue = form.get('quantity')
    const idValue = form.get('id')

    const quantity = quantityValue ? parseInt(quantityValue.toString()) : 0
    const id = idValue ? parseInt(idValue.toString()) : 0

    if (!quantity || !id) return

    // Extract properties from form data
    const propertyObject: { [key: string]: string } = {}
    for (const [key, value] of form.entries()) {
      // Check if the field name starts with 'properties['
      if (key.startsWith('properties[') && key.endsWith(']')) {
        // Extract the property name between brackets
        const propertyName = key.slice(11, -1)
        propertyObject[propertyName] = value.toString()
      }
    }

    const data = await cart.addLineItems([
      {
        id,
        quantity,
        properties: Object.keys(propertyObject).length > 0 ? propertyObject : undefined
      }
    ])

    if (data) return

    if (!data) {
      console.error('Failed to add item to cart', data)
    }
  }
}
